import JassEventId from './eventid';

/**
 * type limitop
 */
export default class JassLimitOp extends JassEventId {}
